// @index(['./!(*.spec).ts', './*/index.ts'], f => `export * from '${f.path.replace(/\/index$/, '')}';`)
export * from './form-card-control.provider';
export * from './form-card.component';
// @endindex